import React, { useState, useEffect } from "react"
import { Button } from "@mui/material"
import { Search, Close } from "@mui/icons-material";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { toast } from "react-toastify";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { getAllClientProject } from "src/thunks/clientProjects";
import { EditDepotPersonal } from "src/thunks/depotUsers";
import toastMessages from "src/constant/toastMessages.json";
import { Loader } from "src/components/loader";
import { GetError } from "src/constant";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";


export const AssignProject = ({ handleViewRecordButtonClick, setAssignProjectModel, selectedData }) => {

    /** redux store useDispatch & useSelector ------------------------------ **/
    const dispatch = useDispatch();
    const { clientProject } = useSelector((state) => state?.clientProjects);

    /** hooks useState ----------------------------------------------------- **/
    const [projectArray, setProjectArray] = useState([]);
    const [selectedProjects, setSelectedProjects] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [loader, setLoader] = useState(false);

    /** hooks useEffect----------------------------------------------------- **/
    useEffect(() => {
        getAllClientsData();
    }, [])

    useEffect(() => {
        setInitialProjectArray();
    }, [clientProject])

    /** Function to initialize the project array ------------------- **/
    const setInitialProjectArray = () => {
        const allClientsProjects = _.uniqBy(_.flatMap(clientProject, 'projects'), 'id');
        const remainingProjects = _.differenceBy(allClientsProjects, selectedData?.projects, 'id');
        setProjectArray(applySelectedState([...remainingProjects]));
    }

    /** Function to retrieve all clients with projects. ------------------- **/
    const getAllClientsData = async () => {
        setLoader(true);
        try {
            await dispatch(getAllClientProject()).unwrap();
            setLoader(false);
        } catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");
            setLoader(false);
        }
    };

    const handleAssignProjectModelClose = () => {
        setAssignProjectModel(false);
    };

    /** Function executes when clicking on a project checkbox from the assign project modal-------------------**/
    const HandleAllocatedChecked = (id) => {
        let Data = _.map(projectArray, (d) => {
            let temp = { ...d }
            if (d.id === id) {
                temp.selected = !temp.selected;
                if (temp.selected) {
                    setSelectedProjects([...selectedProjects, temp]);
                } else {
                    setSelectedProjects(selectedProjects.filter((project) => project.id !== id));
                }
            }
            return temp;
        });
        setProjectArray([...Data]);
    }

    const applySelectedState = (array) => {
        return array.map(item => {
            const selectedItem = selectedProjects.find(proj => proj.id === item.id);
            return selectedItem ? { ...item, selected: true } : item;
        });
    }

    /** Function executes when searching for a project by name ----------------- **/
    const handleSearchInputChange = (e) => {
        const searchText = e.target.value;
        setSearchValue(searchText);
        if (searchText === "") {
            setInitialProjectArray();
        } else {
            const newFilter = projectArray.filter((value) => {
                return value.name.toLowerCase().includes(searchText.toLowerCase());
            });
            setProjectArray(applySelectedState(newFilter));
        }
    }

    /** Function executes when clearing the entered search value --------------------- **/
    const handleClearSearchText = () => {
        handleSearchInputChange({ target: { value: "" } })
        setInitialProjectArray();
    }

    /** Function executes while assigning the project. ------------------ **/
    const handleAssignProjectSubmit = async () => {
        const oldProjectsArray = selectedData?.projects
        const newProjectArray = _.filter(projectArray, (d) => d.selected == true);
        const mergedProjectArray = [...oldProjectsArray, ...newProjectArray]
        try {
            let ModelData = {
                "firstName": selectedData?.firstName,
                "lastName": selectedData?.lastName,
                "middleName": selectedData?.middleName || "",
                "role": "ProjectManager",
                "email": selectedData?.email,
                "username": selectedData?.email,
                "address": { "street1": "", "country": "", "city": "", "zip": "" },
                "phoneNumber": selectedData?.phoneNumber,
                "profileUrl": selectedData?.profileUrl,
                "projects": _.map(mergedProjectArray, (d) => ({ id: d?.id, name: d?.name })),
                assignProject: newProjectArray
            };
            ModelData = {
                data: ModelData,
                id: selectedData?.id,
                "isParentResourceUpdated": false,
            };
            let result = await dispatch(EditDepotPersonal(ModelData)).unwrap();
            if (result) {
                setTimeout(() => {
                    dispatch(getAllNofificationForDashboard(1, 20));
                }, 2000);
                setAssignProjectModel(false);
                toast.success(toastMessages.projectAssigned)
                handleViewRecordButtonClick();
            }
        }
        catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");
        }
    }

    if (loader) {
        return <Loader />;
    }

    return (
        <>
            <div>
                <div className="depot-form-header-style" style={{ paddingLeft: 200 }}>
                    <span className="allocate-mgnr-header-color me-2">ASSIGN PROJECT</span>
                    <span className="allocate-mgnr-subheader-color">{selectedData && selectedData.projects?.length > 0 && selectedData?.projects[0]?.clientName || ""} / {selectedData?.firstName || ""} {selectedData?.lastName || ""}</span>

                </div>
                <div style={{ marginTop: 40 }}
                >
                    <div style={{ paddingLeft: 200, paddingRight: 200 }}>
                        <div className="row">
                            <div className="col-md-4" style={{ position: "relative" }}>
                                <input className="search-input-for-depot-personal-tab" style={{ width: "100%" }} value={searchValue} type="text" placeholder="Search by manager..." onChange={handleSearchInputChange} />
                                <div className="search-icon-allocate-mgnr-style">
                                    {searchValue !== "" ? <Close style={{ cursor: "pointer", top: 0 }} onClick={handleClearSearchText} /> :
                                        <Search style={{ top: 0 }} />}
                                </div>
                            </div>
                            <div className="col-md-8 d-flex justify-content-end">
                            </div>
                        </div>
                        <div className="table-responsive allocate-mgr-tbl-style mt-3">
                            <table className="table assign-project-table table-borderless">
                                <thead>
                                    <tr>
                                        <th >PROJECT</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {projectArray && projectArray[0] ? projectArray.map((item, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <tr>
                                                    <td>{item.name}</td>
                                                    <td className="d-flex justify-content-end">
                                                        <input
                                                            checked={item.selected}
                                                            onChange={() => HandleAllocatedChecked(item.id)}
                                                            style={{ width: 18, height: 18, cursor: "pointer" }} type="checkbox" />
                                                    </td>
                                                </tr >
                                            </React.Fragment>
                                        )
                                    }) :
                                        (
                                            <tr>
                                                <td colSpan="8" style={{ textAlign: "center" }}>
                                                    No projects found to add
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex flex-row justify-content-between" style={{ marginTop: 40, marginBottom: 20 }} >
                            <Button variant="outlined" className="btn-bootstrap-submit-style" style={{ color: "red", borderColor: "red" }} startIcon={<CancelIcon />} onClick={() => handleAssignProjectModelClose()}>
                                Cancel
                            </Button>
                            <Button variant="outlined" className="btn-bootstrap-submit-style" startIcon={<CheckCircleIcon />} type="submit" onClick={() => handleAssignProjectSubmit()}
                            >
                                Submit
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}